import {
  ClipboardPen,
  Facebook,
  House,
  Instagram,
  Linkedin,
  Phone,
} from "lucide-react";
import React, { useRef, useState } from "react";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import bgteal from "../Images/tealback.png";

const ContactPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [mobnum, setMobnum] = useState("");
  const [success, setSuccess] = useState(false); // State for success modal
  const [showModal, setShowModal] = useState(false); // State for modal visibility
  const [contentModal, setcontentModal] = useState("");
  const form = useRef();

  const sendEmail = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("http://127.0.0.1:5000/admin/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: name,
          email: email,
          mobnum: mobnum,
          message: message,
        }),
      });

      if (response.ok) {
        setSuccess(true); // Set success to true when email is sent
        setShowModal(true); // Show the modal dialog
        setcontentModal("Message Sent Successfully!");

        setTimeout(() => setShowModal(false), 6000); // Hide the modal after 3 seconds
      } else {
        setSuccess(true); // Set success to true when email is sent
        setShowModal(true); // Show the modal dialog
        setcontentModal(
          "Message Failed to Send \n Please check for missing information!"
        );
        setTimeout(() => setShowModal(false), 6000); // Hide the modal after 3 seconds
      }
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };

  return (
    <div
      className=""
      style={{
        backgroundImage: `url(${bgteal})`,
        backgroundSize: "cover",
        backgroundPosition: "top left",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed", // Fix background movement
      }}
    >
      <Header />

      <div className=" min-h-screen text-white flex flex-col items-center justify-center pt-8 md:pt-2 lg:pt-0 lg:mb-20 md:mb-16 mb-10 ">
        <h1 className="lg:ml-8 ml-1 text-4xl lg:text-5xl mb-2 text-white text-left font-semibold mt-2 md:mt-4 lg:mt-12">
          Contact Us
        </h1>

        {/* Contact Form Layout */}
        <div className="flex flex-col md:flex-row w-full max-w-6xl mt-8 p-6">
          <div className="w-full md:w-1/2 px-8 bg-teal-50 rounded-lg text-teal-900 p-4">
            <div className="text-left mb-8 animate-fade-in lg:mr-10 mr-4 lg:ml-8">
              <div className="mb-4 md:mb-6 lg:mb-8 border-b-2 border-b-teal-900 pb-4 pt-6">
                <h3 className="text-lg font-semibold mb-2 flex items-center">
                  <span className="mr-2">
                    <House className="w-6 h-6 text-gray-500" />
                  </span>
                  Offices In
                </h3>
                <p className="mb-2 ml-8">Dubai, Pakistan</p>
              </div>
              <div className="mb-4 md:mb-6 lg:mb-8 border-b-2 border-b-teal-900 pb-4">
                <h3 className="text-lg font-semibold mb-2 flex items-center">
                  <span className="mr-2">
                    <Phone className="w-6 h-6 text-gray-500" />
                  </span>
                  Get In Touch
                </h3>
                <p className="mb-2 ml-8">+92 302 0153650</p>
              </div>
              <div className="mt-4 border-b-2 border-b-teal-900 pb-4">
                <h3 className="text-lg font-semibold mb-2 flex items-center">
                  <span className="mr-2">
                    <ClipboardPen className="w-6 h-6 text-gray-500" />
                  </span>
                  Consultation
                </h3>
                <p className="mb-2 ml-8">
                  We Provide Free Consultation and Customized Quotation
                </p>
              </div>
              <div className="mt-8 ml-0">
                <h3 className="text-lg font-semibold mb-4 text-gray-600 ">
                  Other Ways to Connect
                </h3>
                <div className="flex space-x-6">
                  <Facebook className="w-8 h-8 text-teal-800 hover:text-teal-600 cursor-pointer" />
                  <Instagram className="w-8 h-8 text-teal-800 hover:text-teal-600 cursor-pointer" />
                  <Linkedin className="w-8 h-8 text-teal-800 hover:text-teal-600 cursor-pointer" />
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="md:w-1/2 md:block p-2 md:mr-8">
            <h1 className="lg:ml-8 ml-2 block mt-6 lg:hidden md:hidden text-2xl font-bold lg:text-4xl  mb-6 text-white text-center">
              Send Us Your Query
            </h1>
            <div className="w-full lg:ml-8 p-6 text-teal-50 shadow-lg rounded-xl border shadow-teal-400 bg-teal-200 bg-opacity-30">
              <form className="space-y-4" ref={form} onSubmit={sendEmail}>
                <div>
                  <h3 className="block text-sm font-medium mb-1">Name</h3>
                  <input
                    type="text"
                    placeholder="Name"
                    onChange={(e) => setName(e.target.value)}
                    className=" focus:border-teal-300 text-gray-300 w-full border border-teal-600 rounded-sm p-4"
                  />
                </div>
                <div>
                  <h3 className="block text-sm font-medium mb-1">Email</h3>
                  <input
                    type="email"
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    className="text-gray-300 w-full border border-teal-600 rounded-sm p-4"
                  />
                </div>
                <div>
                  <h3 className="block text-sm font-medium mb-1">
                    Mobile Number
                  </h3>
                  <input
                    type="text"
                    placeholder="Mobile Number"
                    onChange={(e) => setMobnum(e.target.value)}
                    className="text-gray-300 w-full border border-teal-600 rounded-sm p-4"
                  />
                </div>
                <div>
                  <h3 className="block text-sm font-medium mb-1">Message</h3>
                  <textarea
                    placeholder="Type a message here..."
                    onChange={(e) => setMessage(e.target.value)}
                    className="text-gray-300 w-full border border-teal-600 rounded-sm p-4"
                    rows="4"
                  ></textarea>
                </div>
                <div className="flex justify-center">
                  <button  type="submit" class="px-5 z-30 py-3 bg-teal-500 bg-opacity-70 border-teal-50 border rounded-md text-white relative font-medium after:-z-20 hover:text-white after:absolute after:h-1 after:w-1 after:bg-teal-300 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700  text-lg">
                   
                     Send Message
                 
                  </button>
                 
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Success Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 ">
          <div className="bg-white rounded-lg p-8 text-center mx-20">
            <h2 className="text-xl font-semibold text-teal-900 mb-4">
              {contentModal}
            </h2>
            <p className="text-teal-800 mb-6">Thank you for contacting us.</p>
            <button
              onClick={() => setShowModal(false)}
              className="text-teal-900 bg-teal-100 px-6 py-2 rounded-md hover:bg-teal-200"
            >
              Close
            </button>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default ContactPage;
